// extracted by mini-css-extract-plugin
export default {"JobsApp":"JobsApp_JobsApp__ODVhM","bpk-no-touch-support":"JobsApp_bpk-no-touch-support__ZWEzY"};